<div class="fill-height p-2">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <article *ngFor="let item of [0,1]; let i = index">
    <div class="p-2">
      <u class="zx-text-tiny text-gray fw-bold" *ngIf="i === 0">{{ "su-management.open-products" | translate }}</u>
      <u class="zx-text-tiny text-gray fw-bold" *ngIf="i === 1">{{ "su-management.close-products" | translate }}</u>
    </div>
    <mat-card>
      <mat-accordion multi="true" *ngIf="products.length > 0 && !isLoading">
        <mat-expansion-panel *ngFor="let product of products">
          <mat-expansion-panel-header *ngIf="product.products.serial_name !== 'express' &&
          ((!product.products.hide && i === 0) || (product.products.hide && i === 1))">
            <span>
              <b>{{ "choose-product.naming." + product.products.serial_name | translate }}</b>
            </span>
          </mat-expansion-panel-header>
          <div *ngIf="product.products.serial_name !== 'express'&&
          ((!product.products.hide && i === 0) || (product.products.hide && i === 1))"
            class="d-flex flex-column flex-lg-row gap-3 w-100">
            <div class="d-flex flex-column gap-2 px-4 flex-grow-1">
              <!-- serial name & status -->
              <div class="d-flex row">
                <!-- serial name -->
                <span class="col-12 col-lg-4 pb-2 pb-lg-0">
                  <u>{{ 'su-management.products_serial-name' | translate }}</u>
                  <span>: </span>
                  <b>{{ product.products.serial_name }}</b>
                </span>
                <!-- status -->
                <div class="col-12 col-lg-8">
                  <div class="d-flex flex-column gap-2">
                    <div class="d-flex gap-4">
                      <!-- close? -->
                      <span>
                        <u>{{ 'su-management.products_close' | translate }}</u>
                        <b class="text-green" *ngIf="!product.products.close">
                          {{ 'su-management.products_no' | translate }}
                        </b>
                        <b class="text-red" *ngIf="product.products.close">
                          {{ 'su-management.products_yes' | translate }}
                        </b>
                      </span>
                      <!-- inform slack on new orders? -->
                      <span>
                        <u>{{ 'su-management.products_inform-slack' | translate }}</u>
                        <b class="text-green" *ngIf="!product.products.inform_slack_of_new_orders">
                          {{ 'su-management.products_no' | translate }}
                        </b>
                        <b class="text-red" *ngIf="product.products.inform_slack_of_new_orders">
                          {{ 'su-management.products_yes' | translate }}
                        </b>
                      </span>
                      <!-- anydesk product.products.printers[0].anydesk -->
                      <a [href]="'anydesk://' + product.products.printers[0].anydesk" target="_blank"
                        class="anydesk-button">
                        <img src="assets/images/anydesk-icon.png" alt="Anydesk Icon" class="svg zx-small-icon-size">
                      </a>
                    </div>
                    <!-- close msg -->
                    <span *ngIf="product.products.close">
                      <u>{{ 'su-management.products_close-msg' | translate }}</u>
                      <span>: </span>
                      <span class="text-red" *ngIf="product.products.close">
                        {{ product.products.close_msg }}
                      </span>
                    </span>
                  </div>
                </div>

              </div>
              <!-- --------------papers--------------: -->
              <u class="zx-text-tiny text-gray fw-bold">{{ 'paper-type.title' | translate }}</u>
              <div *ngIf="product.products.printers[0].inputBins && product.products.printers[0].inputBins.length > 0"
                class="row">
                <div class="d-flex flex-column col-12 col-lg-6 p-2 gap-1"
                  *ngFor="let paper of product.products.printers[0].inputBins; let i = index">
                  <div class="d-flex flex-column w-100 p-2 rounded-2 zx-border-gray-v-light gap-1">
                    <!-- serial-name -->
                    <div class="d-flex w-100 justify-content-between">
                      <span>
                        <u>{{ 'su-management.products_serial-name' | translate }}</u>
                        <span>: </span>
                        <b>{{ paper.paperType.paperType }}</b>
                      </span>
                      <span class="text-gray">{{"#" + (i + 1) }}</span>
                    </div>
                    <!-- names -->
                    <div class="d-flex w-100">
                      <!-- full -->
                      <span class="w-50">
                        <u>{{ 'su-management.products_paper-name' | translate }}</u>
                        <span>: </span>
                        <b>{{ "paper-type.name." + paper.paperType.paperType | translate }}</b>
                      </span>
                      <!-- short -->
                      <span class="w-50">
                        <u>{{ 'su-management.products_paper-name-short' | translate }}</u>
                        <span>: </span>
                        <b>{{ "paper-type.name-short." + paper.paperType.paperType | translate }}</b>
                      </span>
                    </div>
                    <!-- width & weight -->
                    <div class="d-flex w-100">
                      <!-- width -->
                      <span class="w-50">
                        <u>{{ 'su-management.products_paper-width' | translate }}</u>
                        <span>: </span>
                        <span>
                          <b>{{ (paper.paperType.paperWidth / 1000) | number:'1.2-2' }}</b>
                          <b class="zx-text-tiny">{{ 'su-management.products_paper-width-cm' | translate }}</b>
                        </span>
                      </span>
                      <!-- weight -->
                      <span class="w-50">
                        <u>{{ 'su-management.products_paper-weight' | translate }}</u>
                        <span>: </span>
                        <span>
                          <b>{{ paper.paperType.paperWeight }}</b>
                          <b class="zx-text-tiny">{{ 'su-management.products_paper-weight-g' | translate }}</b>
                        </span>
                      </span>
                    </div>
                    <!-- quality  -->
                    <span>
                      <u>{{ 'su-management.products_paper-quality' | translate }}</u>
                      <span>:</span>
                      <span>
                        <b> {{ paper.paperType.paperPrinterQuality }}</b>
                      </span>
                    </span>
                    <hr class="mt-2 mb-1 mx-3">
                    <!-- status -->
                    <u class="zx-text-tiny text-gray fw-bold">
                      {{ 'su-management.products_paper-status' | translate }}
                    </u>
                    <!-- Length -->
                    <span>
                      <u>
                        {{ 'su-management.products_paper-linger-length' | translate }}
                      </u>
                      <span>: </span>
                      <span>
                        <b [class.text-red]="paper.status.lingerLength / 100000 < nimlengthUnit"
                          [class.text-orange]="paper.status.lingerLength / 100000 < nimlengthUnit * 2">
                          {{ (paper.status.lingerLength / 100000) | number:'1.2-2' }}
                        </b>
                        <b class="zx-text-tiny" [class.text-red]="paper.status.lingerLength / 100000 < nimlengthUnit"
                          [class.text-orange]="paper.status.lingerLength / 100000 < nimlengthUnit * 2">
                          {{ 'su-management.products_m' | translate }}
                        </b>
                        <span class="zx-text-tiny" [class.text-red]="paper.status.lingerLength / 100000 < nimlengthUnit"
                          [class.text-orange]="paper.status.lingerLength / 100000 < nimlengthUnit * 2"> = </span>
                        <span [class.text-red]="paper.status.lingerLength / 100000 < nimlengthUnit"
                          [class.text-orange]="paper.status.lingerLength / 100000 < nimlengthUnit * 2"
                          class="zx-text-tiny">
                          %
                        </span>
                        <span [class.text-red]="paper.status.lingerLength / 100000 < nimlengthUnit"
                          [class.text-orange]="paper.status.lingerLength / 100000 < nimlengthUnit * 2">
                          {{ paper.status.lingerPercent }}
                        </span>
                      </span>
                    </span>
                    <!-- detection & enableReplace -->
                    <div class="d-flex w-100">
                      <!-- detection  -->
                      <span class="w-50">
                        <u>{{ 'su-management.products_paper-detection' | translate }}</u>
                        <span>: </span>
                        <span>
                          <b class="text-green" *ngIf="paper.status.detection">
                            {{ 'su-management.products_paper-detection-true' | translate }}
                          </b>
                          <u class="text-red fw-bold" *ngIf="!paper.status.detection">
                            {{ 'su-management.products_paper-detection-false' | translate }}
                          </u>
                          <img *ngIf="!paper.status.detection" src="/assets/images/exclamation-icon-red.svg"
                            class="exclamation-icon-red svg">
                        </span>
                      </span>
                      <!-- enableReplace  -->
                      <span class="w-50">
                        <u>{{ 'su-management.products_paper-replace' | translate }}</u>
                        <span>
                          <b class="text-green" *ngIf="!paper.status.enableReplace">
                            {{ 'su-management.products_no' | translate }}
                          </b>
                          <u class="text-red fw-bold" *ngIf="paper.status.enableReplace">
                            {{ 'su-management.products_yes' | translate }}
                          </u>
                          <img *ngIf="paper.status.enableReplace" src="/assets/images/exclamation-icon-red.svg"
                            class="exclamation-icon-red svg">
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- --------------manigment--------------: -->
              <div class="row">
                <u class="zx-text-tiny text-gray fw-bold col-6">
                  {{ 'su-management.products_bm' | translate }}
                </u>
                <u *ngIf="product.products.st.length > 0" class="zx-text-tiny text-gray fw-bold col-6">
                  {{ 'su-management.products_st' | translate }}
                </u>
              </div>
              <div class="row">
                <!-- bm -->
                <div class="d-flex flex-column col-12 col-lg-6 p-2 gap-1">
                  <div class="d-flex flex-column w-100 p-2 rounded-2 zx-border-gray-v-light gap-1">
                    <!-- name -->
                    <span>
                      <u>{{ 'su-management.products_name' | translate }}</u>
                      <span>: </span>
                      <b>{{product.products.bm.displayName}}</b>
                    </span>
                    <div class="d-flex w-100 rounded-2 gap-3">
                      <!-- phone -->
                      <span>
                        <u>{{ 'su-management.products_phone' | translate }}</u>
                        <span>: </span>
                        <a class="c-pointer text-green"
                          (click)="copyToClipboard('0' + product.products.bm.phone, 'phone')">0{{product.products.bm.phone}}</a>
                      </span>
                      <!-- email -->
                      <span>
                        <u>{{ 'su-management.products_email' | translate }}</u>
                        <span>: </span>
                        <a class="c-pointer text-green"
                          (click)="copyToClipboard(product.products.bm.email, 'email')">{{product.products.bm.email}}</a>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- st -->
                <div *ngIf="product.products.st.length > 0" class="d-flex flex-column col-12 col-lg-6 p-2 gap-1">
                  <div class="d-flex flex-column w-100 gap-1">
                    <div *ngFor="let st of product.products.st"
                      class="d-flex flex-column w-100 p-2 rounded-2 zx-border-gray-v-light gap-1">
                      <!-- name -->
                      <span>
                        <u>{{ 'su-management.products_name' | translate }}</u>
                        <span>: </span>
                        <b>{{st.displayName}}</b>
                      </span>
                      <div class="d-flex w-100 rounded-2 gap-3">
                        <!-- phone -->
                        <span>
                          <u>{{ 'su-management.products_phone' | translate }}</u>
                          <span>: </span>
                          <a class="c-pointer text-green"
                            (click)="copyToClipboard('0' + st.phone, 'phone')">0{{st.phone}}</a>
                        </span>
                        <!-- email -->
                        <span>
                          <u>{{ 'su-management.products_email' | translate }}</u>
                          <span>: </span>
                          <a class="c-pointer text-green" (click)="copyToClipboard(st.email, 'email')">{{st.email}}</a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- --------------adress--------------: -->
              <u class="zx-text-tiny text-gray fw-bold">{{ 'su-management.place' | translate }}</u>
              <div class="w-100 d-flex gap-3 pb-lg-2">
                <span>
                  <u>{{ 'su-management.products_city' | translate }}</u>
                  <span>:</span>
                  <span> {{ "choose-product.city." + product.products.serial_name | translate }}</span>
                </span>
                <span>
                  <u>{{ 'su-management.products_short-address' | translate }}</u>
                  <span>:</span>
                  <span> {{ "choose-product.short-address." + product.products.serial_name | translate }}</span>
                </span>
                <span>
                  <u>{{ 'su-management.products_address-exact' | translate }}</u>
                  <span>:</span>
                  <span> {{ "choose-product.address-exact." + product.products.serial_name | translate }}</span>
                </span>
              </div>
            </div>
            <!-- logo -->
            <div class="d-flex flex-lg-column gap-2 mx-4 pb-2">
              <span>
                <u>{{ "su-management.products_logo" | translate }}</u>
                <span>:</span>
              </span>
              <div class="zx-medium-icon-size zx-huge-icon-size-lg p-1 p-lg-2 zx-border-gray-v-light rounded-2">
                <img class="w-100 h-100 object-fit-contain"
                  [src]="'assets/images/products/' + product.products.serial_name + '.png'"
                  [alt]="product.products.serial_name  + ' Logo'">
              </div>
            </div>
          </div>
          <!-- action row -->
          <mat-action-row>
            <a [class.text-white]="isDarkMode" mat-button color="primary" [routerLink]="['/productedit', product.id]">
              {{ "su-management.products_edit" | translate }}</a>
            <button [class.text-white]="isDarkMode" mat-button color="warn" [matMenuTriggerFor]="menu">
              {{ "su-management.products_delete" | translate }}
            </button>
            <!-- delet product Confirmation -->
            <mat-menu #menu="matMenu">
              <div class="w-100 d-flex px-3">
                <span class="zx-text-tiny text-red" [class.zx-rtl]="isRTL">
                  {{ "su-management.products_delete-confirm" | translate }}
                </span>
              </div>
              <div class="w-100 d-flex" [class.flex-row-reverse]="isRTL">
                <button class="d-flex justify-content-center w-50" mat-menu-item (click)="onDeleteConfirm(product.id)">
                  <span class="text-center zx-text-tiny fw-bold text-red">
                    {{ "su-management.products_delete" | translate }}
                  </span>
                </button>
                <button class="d-flex justify-content-center w-50" mat-menu-item>
                  <span class="text-center zx-text-tiny fw-bold text-green">
                    {{ "su-management.products_cancel" | translate }}
                  </span>
                </button>
              </div>
            </mat-menu>
            <!-- // delet product Confirmation -->
          </mat-action-row>
          <!-- // action row -->
        </mat-expansion-panel>
      </mat-accordion>
      <div class="spacer"></div>
    </mat-card>
  </article>
</div>

<div class="p-2">
  <mat-paginator class="m-0" [length]="totalProducts" [pageSize]="productsPerPage" [pageSizeOptions]="pageSizeOptions"
    (page)="onChangedPage($event)" *ngIf="products.length > 0"></mat-paginator>
  <div class="pt-2">
    <button class="w-100 rounded-pill" mat-raised-button type="button" (click)="toProductsCreate()">
      {{ "su-management.products_create" | translate }}
    </button>
  </div>
</div>